import { create } from 'zustand'

type AmountVisibilityState = {
  visible: boolean
  toggle(): void
}

export const useAmountVisibility = create<AmountVisibilityState>(set => ({
  visible: true,
  toggle: () => set(state => ({ visible: !state.visible }))
}))
